import { PageEvent } from '@angular/material/paginator';
import { IAuPaginationData } from '@shared/ui-components/au-paginator/pagination-page.info';

export class MaterialToAuPaginationDataConverter {
	convertToAuPaginationData(
		pageEventData: PageEvent,
		cursors: { firstNodeCursor; lastNodeCursor }
	): IAuPaginationData {
		const paginationData: IAuPaginationData = {};

		if (this.pagingForward(pageEventData)) {
			/** Forward direction. N elements after last cursor */
			paginationData.after = cursors.lastNodeCursor;
			paginationData.first = pageEventData.pageSize;
		} else if (this.pagingRevers(pageEventData)) {
			/** Reverse direction. N elements before first cursor */
			paginationData.before = cursors.firstNodeCursor;
			paginationData.last = pageEventData.pageSize;
		} else {
			/** initial state. N elements from first page */

			paginationData.first = pageEventData.pageSize;
		}
		return paginationData;
	}

	private pagingForward(pageEventData: PageEvent): boolean {
		return pageEventData.pageIndex > pageEventData.previousPageIndex;
	}

	private pagingRevers(pageEventData: PageEvent): boolean {
		return (
			pageEventData.pageIndex < pageEventData.previousPageIndex &&
			pageEventData.pageIndex !== 0
		);
	}
}
